<div
  class="toolbar-user"
  (furyClickOutside)="onClickOutside($event)"
  fxFlex="grow"
>
  <button
    class="button"
    mat-button
    (click)="toggleDropdown()"
    [class.open]="isOpen"
    fxFlex="grow"
  >
    <span
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <img
        class="avatar"
        src="assets/images/avatars/alice.jpg"
      />
      <span
        class="name"
        fxHide
        fxShow.gt-sm
        >{{ user.userName }}</span
      >
      <mat-icon
        class="icon"
        fxHide
        fxShow.gt-sm
        >keyboard_arrow_down</mat-icon
      >
    </span>
  </button>

  <div
    class="dropdown"
    [class.open]="isOpen"
  >
    <div class="content">
      <div class="preferences">
        <app-preferences-picker [compact]="true"></app-preferences-picker>
      </div>
      <div class="list">
        <div
          class="list-item"
          matRipple
          [routerLink]="['/settings/users', user.userName]"
          [routerLinkActive]="['active']"
          (click)="isOpen = false"
        >
          <mat-icon class="list-item-icon">account_circle</mat-icon>
          <span>Profile</span>
        </div>
        @if (canPickTheme()) {
        <div
          class="list-item"
          matRipple
          role="button"
          tabindex="0"
          (click)="useSteelTheme()"
          (keydown.enter)="useSteelTheme()"
        >
          <mat-icon class="list-item-icon">palette</mat-icon>
          <span>{{ 'tryTheSteelTheme' | translate }}</span>
        </div>
        }
        <div
          class="list-item"
          matRipple
          (click)="logout()"
        >
          <mat-icon class="list-item-icon">exit_to_app</mat-icon>
          <span>Logout</span>
        </div>
      </div>
    </div>
  </div>
</div>
